var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ingresante-a-b-m-docente',{attrs:{"headers":_vm.headers}})}
var staticRenderFns = []

export { render, staticRenderFns }